import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import BasePage from 'components/BasePage/BasePage';
import Content from 'components/BasePage/Content';

import { analyseRoutes, ROUTE_ANALYSE_OVERVIEW } from './RouteList';

@observer
export default class AnalyseApp extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <BasePage>
        <Content>
          <Switch>
            {analyseRoutes.map(route => (
              <Route
                key={`${route.path}`}
                path={`${route.path}`}
                component={route.component}
              />
            ))}
            <Redirect to={ROUTE_ANALYSE_OVERVIEW} />
          </Switch>
        </Content>
      </BasePage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AnalyseApp.js